import { render, staticRenderFns } from "./purchasePup.vue?vue&type=template&id=6f14cd6c&scoped=true&"
import script from "./purchasePup.vue?vue&type=script&lang=js&"
export * from "./purchasePup.vue?vue&type=script&lang=js&"
import style0 from "./purchasePup.vue?vue&type=style&index=0&id=6f14cd6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f14cd6c",
  null
  
)

export default component.exports